import type { Identifier } from "ra-core";

export const CONTACT_WHATSAPP_SECTION_ID = "whatsapp";

/** `?claim=1` on the contact page claims a needs-reply inbox conversation once
 *  (see ContactAttentionBanner) and is then stripped from the URL. */
export const CONTACT_WHATSAPP_CLAIM_PARAM = "claim";

export function contactWhatsAppSectionPath(contactId: Identifier) {
  return `/contacts/${encodeURIComponent(String(contactId))}/show#${CONTACT_WHATSAPP_SECTION_ID}`;
}

export function contactWhatsAppClaimPath(contactId: Identifier) {
  return `/contacts/${encodeURIComponent(String(contactId))}/show?${CONTACT_WHATSAPP_CLAIM_PARAM}=1#${CONTACT_WHATSAPP_SECTION_ID}`;
}
